import { all } from "redux-saga/effects";

function* rootSaga() {
  yield all([]);
}

export default rootSaga;
